import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import clearString from '~/prix/utils/bulk/clearString'
import {
  parseStringArray,
  parseEnumEmptyString,
  parseCsvCalendarDate,
} from '~/prix/utils/bulk/csvValueParsers'

const activity: Dataset = {
  schema: 'public_health',
  table: 'activity',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => (original != null ? Number(original) : null),
    activity_date: original => parseCsvCalendarDate(original as string),
    location: original => clearString(original as string),
    participants_count: original => (original != null ? Number(original) : null),
    shift: original => parseEnumEmptyString(original as string),
    activity_type: original => parseEnumEmptyString(original as string),
    practices: original => parseStringArray(original as string),
    target_audiences: original => parseStringArray(original as string),
    health_practices: original => parseStringArray(original as string),
    meeting_themes: original => parseStringArray(original as string),
    responsible_cns: original => clearString(original as string),
    cnes: original => clearString(original as string),
    inep_code: original => clearString(original as string),
    sigtap_code: original => clearString(original as string),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default activity
